import { FlexBox } from "@brg/ui";
import { FC } from "react";
import { MobileSaveIcon } from "shared/assets/32/mobile-save-new-icon";
import styled from "styled-components";

const ButtonWrapper = styled.button<{ disabled?: boolean }>`
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    user-select: ${({ disabled }) => (disabled ? "none" : "auto")};
    outline: none;
    border: none;
    background: none;
    padding: 0;

  &:focus {
    outline: none;
  }
`;

export const MobileSaveBlock: FC<{onClick: () => void, visible?: boolean, disabled?: boolean }> = ({ onClick, visible, disabled }) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) {
            e.stopPropagation();
        } else {
            onClick();
        }
    };
    return (
        <FlexBox style={{ display: visible ? 'flex' : 'none '}} align="center">
            <ButtonWrapper disabled={disabled} onClick={handleClick}>
            <MobileSaveIcon />
            </ButtonWrapper>
        </FlexBox>
    )
}import { FlexBox } from "@brg/ui";
import { FC } from "react";
import { MobileSaveIcon } from "shared/assets/32/mobile-save-new-icon";
import styled from "styled-components";

const ButtonWrapper = styled.button<{ disabled?: boolean }>`
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    user-select: ${({ disabled }) => (disabled ? "none" : "auto")};
    outline: none;
    border: none;
    background: none;
    padding: 0;

  &:focus {
    outline: none;
  }
`;

export const MobileSaveBlock: FC<{onClick: () => void, visible?: boolean, disabled?: boolean }> = ({ onClick, visible, disabled }) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) {
            e.stopPropagation();
        } else {
            onClick();
        }
    };
    return (
        <FlexBox style={{ display: visible ? 'flex' : 'none '}} align="center">
            <ButtonWrapper disabled={disabled} onClick={handleClick}>
            <MobileSaveIcon />
            </ButtonWrapper>
        </FlexBox>
    )
}